import React from 'react';
import ReactDOM from 'react-dom';
import { Render, getElementsByClassName } from 'wse-quiz-component'
import ShadowDOM from 'react-shadow';
import Recaptcha from 'react-google-recaptcha'
const RECAPTCHA_SITE_ID = process.env.REACT_APP_RECAPTCHA_SITE_ID;
import WSEQBManager from './manager';
const quizzes = [];

function createQuizComponent(quiz) {
  window.quizCapcha[quiz.id] = false;
  window.quizCapchaResults[quiz.id] = false;

  let args = {};
  if(!!quiz.args && quiz.args.length){
      try{
        args = JSON.parse(quiz.args);
      } catch(e){
          console.error('could not parse optional quiz args',e)
      }
  }

  const recaptureComponent = (
    <Recaptcha
      ref={(ref) => { window.quizCapcha[quiz.id] = ref; }}
      sitekey={RECAPTCHA_SITE_ID}
      size="invisible"
      onChange={(f) => {
        if (f !== null) {
          window.quizCapchaResults[quiz.id] = f;
          window.reCaptureOk(f);
        }
      }}
    />
  );
  const quizProps = {
      quizId:quiz.id,
      quizData:quiz.data,
      apiUrl:`${process.env.REACT_APP_API_BASE}`,
      onTracking:window._wseqbm.onTracking,
      formArgs:args
  };
  if(!!quiz.countryCode){
      quizProps.countryCode = quiz.countryCode;
  }
  const quizComponent = (
    <div style={{'position': 'relative','width': '100%', 'height': 'auto'}}>
      <link rel="stylesheet" type='text/css' href={quiz.css}></link>
      <Render {...quizProps} />
    </div>
  );

  const shadowDomActivityComponent = (
    <div style={{'position': 'relative','width': '100%', 'height': 'auto'}}>
      {recaptureComponent}
      <ShadowDOM>{quizComponent}</ShadowDOM>
    </div>
  );

  const activityComponent = (
    <div className="wsequiz-noshadow cleanstate">
      {recaptureComponent}
      {quizComponent}
    </div>
  );

  const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if(!is_safari){
    try {
      // note: react-shadow 2.1.0 doesn't work in Safari Version 11.1.
      return ReactDOM.render(shadowDomActivityComponent, quiz.attachTo);
    } catch (e) {
      console.warn('Shadow DOM not available, falling back to base DOM');
      return ReactDOM.render(activityComponent, quiz.attachTo);
    }
  } else {
    console.warn('Avoiding Safari Shadow DOM in safari');
    return ReactDOM.render(activityComponent, quiz.attachTo);
  }
};

getElementsByClassName('wse-quiz').forEach(el => {
  quizzes.push({
    attachTo: el,
    id: el.getAttribute('data-wse-quiz-id'),
    countryCode: el.getAttribute('data-wse-quiz-countrycode'),
    args: el.getAttribute('data-wse-quiz-args'),
    data: el.getAttribute('data-wse-quiz'),
    css: el.getAttribute('data-wse-css-href')
  });
});

window._wseqbm = window._wseqb || new WSEQBManager();
window._wseqbm.addEntries(quizzes);
window.quizCapcha = {};
window.quizCapchaResults = {};

quizzes.forEach(createQuizComponent);



// WEBPACK FOOTER //
// ./src/index.js